"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const levels = [{
  title: "Primaria",
  description: "Apoyo continuo en todas las asignaturas para asentar una base sólida desde el principio.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/level_primaria.png",
  href: "/CoursesPage"
}, {
  title: "ESO",
  description: "Refuerzo en Matemáticas, Lengua, Física y Quimica, Inglés, etc.. para superar con éxito la Educación Secundaria Obligatoria.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/level_eso.png",
  href: "/CoursesPage"
}, {
  title: "Bachillerato",
  description: "Preparación intensiva y enfocada en superar el Bachillerato y alcanzar la nota necesaria para la EBAU.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/level_bachillerato.png",
  href: "/CoursesPage"
}, {
  title: "Universidad",
  description: "Clases particulares individuales o en grupo de asignaturas universitarias de Contabilidad, Matemáticas, Economía, Estadística, etc.. con profesor con una amplia experiencia formativa. años.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/level_universidad.png",
  href: "/CoursesPage"
}];
export default function ClassesLevelsGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="classeslevelsgrid" className="py-20 md:py-24 bg-background overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`max-w-3xl mb-12 md:mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground tracking-tight mb-4">Enseñanza personalizada según tu nivel.</h2>
          <p className="text-lg text-muted-foreground font-sans">
            Ofrecemos apoyo escolar y universitario personalizado para garantizar
            tu éxito en cualquier etapa de tu formación. Encuentra el programa
            que mejor se adapta a tus necesidades.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {levels.map((level, i) => <div key={i} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 100} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <Link to={level.href} className="block h-full group">
                <Card className="h-full overflow-hidden border-border hover:border-primary/50 transition-colors duration-300 shadow-sm hover:shadow-md flex flex-col">
                  <div className="relative overflow-hidden">
                    <AspectRatio ratio={16 / 9}>
                      <img src={level.image} data-wvc-srcset={`${level.image}-wvc-srcset`} data-wvc-sizes={`${level.image}-wvc-sizes`} alt={`Clases de ${level.title}`} className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-500 ease-in-out" loading="lazy" />
                    </AspectRatio>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </div>
                  
                  <CardHeader className="flex-grow pb-4">
                    <CardTitle className="font-default text-xl md:text-2xl text-foreground group-hover:text-primary transition-colors duration-300">
                      {level.title}
                    </CardTitle>
                    <CardDescription className="font-sans text-base text-muted-foreground mt-2 line-clamp-3">
                      {level.description}
                    </CardDescription>
                  </CardHeader>
                </Card>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}